/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_RequestedInputs */

const en_samples_requested = /** @type {(inputs: Samples_RequestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requested`)
};

const es_samples_requested = /** @type {(inputs: Samples_RequestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitado`)
};

/**
* | output |
* | --- |
* | "Requested" |
*
* @param {Samples_RequestedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_requested = /** @type {((inputs?: Samples_RequestedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_RequestedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_requested(inputs)
	return es_samples_requested(inputs)
});